import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { initRemoteConfig } from './services/remoteConfig'
import { initAnalytics } from './services/analytics'

loadFonts()

// Inicializar de forma asíncrona Remote Config y Firebase Analytics
initRemoteConfig()
initAnalytics()

createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app')

